// 產品線清單沒有 API，與後端 internal/productline 同步維護；寫法必須與後端完全一致（連字號、大小寫）。
// 後端另有 PA-Live，前端不開放（只有 KPI Analyze 的 API 路徑固定用它，見 kpi-analyze/constants.js）。
// DW 目前只有 Live-Asia 有資料；其餘三條先讓權限（角色矩陣、RLS）能設定，報表與選項樹會是空的
export const PRODUCT_LINES = ['Live-Asia', 'Slot', 'Arcade', 'Hunter']

// 欄名顯示用；API 值仍用 PRODUCT_LINES 的原字串
export const PRODUCT_LINE_LABELS = { 'Live-Asia': 'Live Asia', Slot: 'Slot', Arcade: 'Arcade', Hunter: 'Hunter' }

// 通用層在角色權限 API 的 product_line 值
export const PRODUCT_LINE_GLOBAL = '*'

export const DEFAULT_PRODUCT_LINE = 'Live-Asia'

const STORAGE_KEY = 'bi.productLine'

function readStoredProductLine() {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    return PRODUCT_LINES.includes(v) ? v : null
  } catch {
    return null
  }
}

// navbar 切換開關：DW 只有 Live-Asia 有資料，其他產品線切過去只會拿到空畫面或 DW 400，
// 所以先鎖住；關閉時連 localStorage 殘留的選擇也忽略，避免測試期存下的值讓使用者卡在空產品線。
export const PRODUCT_LINE_SWITCH_ENABLED = false

export function resolveCurrentProductLine(stored, enabled = PRODUCT_LINE_SWITCH_ENABLED) {
  return enabled && PRODUCT_LINES.includes(stored) ? stored : DEFAULT_PRODUCT_LINE
}

// 目前產品線在整頁生命週期內固定：各頁 API 路徑常數與多個模組級快取（filtersCache、dashboardBrands、
// currencies…）都在 import 時以它定值，所以切換走 switchProductLine 存起來再 reload，不做反應式切換。
export const CURRENT_PRODUCT_LINE = resolveCurrentProductLine(readStoredProductLine())

export function switchProductLine(next) {
  if (!PRODUCT_LINE_SWITCH_ENABLED) return
  if (!PRODUCT_LINES.includes(next) || next === CURRENT_PRODUCT_LINE) return
  try {
    localStorage.setItem(STORAGE_KEY, next)
  } catch {
    return
  }
  location.reload()
}

export function getProductLineOptions() {
  return PRODUCT_LINES.map((key) => ({ key, label: PRODUCT_LINE_LABELS[key] }))
}
